import React, {Component} from 'react';
import UserProfileItem from './user-home-profile-item';

class UserHomeTableProfile extends Component{

    constructor(){
        super();
        this.state = {
            "role": 0,
            "study": [],
            "language": "",
            "confirmed": false,
            "firstname": "",
            "lastname": "",
            "email": "",
            "company_name": "",
            "country": "",
        }
    }

   async componentDidMount(){
      

        try{
            const res = await fetch('http://143.198.24.1:3000/api/user/profile', {
            method: 'GET',
            headers: {'Content-Type':'application/json' , 'Authorization': 'Bearer ' + localStorage["token"] },
        });
            const data = await res.json();
            const userProfileData = data.output;
            this.setState({...userProfileData});
        } catch(err){
            console.error(err);
        }
        
    }
    

    render(){

        return(
           <div className="tab-pane fade" id="profile" role="tabpanel">
               <div className="profile-tab">
                        <UserProfileItem userProfileName={this.state.firstname} userProfilePhoneNumber={null} userProfileCompanyName={this.state.company_name} userProfileEmail={this.state.email} userProfileCountry={this.state.country} userProfilePassword={"***************"} />
                     <div className="text-center">
                        <a className="get-start-btn light-btn red-btn" href="/home">تعديل بياناتك</a>
                     </div>
                </div>
            </div>
                        
            
        );
       
    }

};
export default UserHomeTableProfile;


